// Authentication API functions

import api from './client';
import type { LoginResponse, RefreshResponse, SafeUser, LoginInput } from '@ultisim/shared';

export const authApi = {
  login: (data: LoginInput) =>
    api.post<LoginResponse>('/auth/login', data),

  logout: () =>
    api.post<{ message: string }>('/auth/logout'),

  refresh: () =>
    api.post<RefreshResponse>('/auth/refresh'),

  getMe: () =>
    api.get<SafeUser>('/auth/me'),

  forgotPassword: (email: string) =>
    api.post<{ message: string }>('/auth/forgot-password', { email }),

  resetPassword: (token: string, password: string) =>
    api.post<{ message: string }>('/auth/reset-password', { token, password }),
};

export default authApi;
